/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AddressViewModel } from './AddressViewModel';
import {
    AddressViewModelFromJSON,
    AddressViewModelFromJSONTyped,
    AddressViewModelToJSON,
} from './AddressViewModel';
import type { ContactPersonViewModel } from './ContactPersonViewModel';
import {
    ContactPersonViewModelFromJSON,
    ContactPersonViewModelFromJSONTyped,
    ContactPersonViewModelToJSON,
} from './ContactPersonViewModel';
import type { ThirdPartyOrganisationFinancialAndTax } from './ThirdPartyOrganisationFinancialAndTax';
import {
    ThirdPartyOrganisationFinancialAndTaxFromJSON,
    ThirdPartyOrganisationFinancialAndTaxFromJSONTyped,
    ThirdPartyOrganisationFinancialAndTaxToJSON,
} from './ThirdPartyOrganisationFinancialAndTax';
import type { TrustPartyDetailsViewModel } from './TrustPartyDetailsViewModel';
import {
    TrustPartyDetailsViewModelFromJSON,
    TrustPartyDetailsViewModelFromJSONTyped,
    TrustPartyDetailsViewModelToJSON,
} from './TrustPartyDetailsViewModel';

/**
 * 
 * @export
 * @interface TrustThirdPartyViewModel
 */
export interface TrustThirdPartyViewModel {
    /**
     * 
     * @type {number}
     * @memberof TrustThirdPartyViewModel
     */
    partyId?: number;
    /**
     * 
     * @type {TrustPartyDetailsViewModel}
     * @memberof TrustThirdPartyViewModel
     */
    trustDetails?: TrustPartyDetailsViewModel;
    /**
     * 
     * @type {ThirdPartyOrganisationFinancialAndTax}
     * @memberof TrustThirdPartyViewModel
     */
    financialAndTax?: ThirdPartyOrganisationFinancialAndTax;
    /**
     * 
     * @type {ContactPersonViewModel}
     * @memberof TrustThirdPartyViewModel
     */
    contactPerson?: ContactPersonViewModel;
    /**
     * 
     * @type {AddressViewModel}
     * @memberof TrustThirdPartyViewModel
     */
    registeredAddress?: AddressViewModel;
}

/**
 * Check if a given object implements the TrustThirdPartyViewModel interface.
 */
export function instanceOfTrustThirdPartyViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TrustThirdPartyViewModelFromJSON(json: any): TrustThirdPartyViewModel {
    return TrustThirdPartyViewModelFromJSONTyped(json, false);
}

export function TrustThirdPartyViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrustThirdPartyViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partyId': !exists(json, 'PartyId') ? undefined : json['PartyId'],
        'trustDetails': !exists(json, 'TrustDetails') ? undefined : TrustPartyDetailsViewModelFromJSON(json['TrustDetails']),
        'financialAndTax': !exists(json, 'FinancialAndTax') ? undefined : ThirdPartyOrganisationFinancialAndTaxFromJSON(json['FinancialAndTax']),
        'contactPerson': !exists(json, 'ContactPerson') ? undefined : ContactPersonViewModelFromJSON(json['ContactPerson']),
        'registeredAddress': !exists(json, 'RegisteredAddress') ? undefined : AddressViewModelFromJSON(json['RegisteredAddress']),
    };
}

export function TrustThirdPartyViewModelToJSON(value?: TrustThirdPartyViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PartyId': value.partyId,
        'TrustDetails': TrustPartyDetailsViewModelToJSON(value.trustDetails),
        'FinancialAndTax': ThirdPartyOrganisationFinancialAndTaxToJSON(value.financialAndTax),
        'ContactPerson': ContactPersonViewModelToJSON(value.contactPerson),
        'RegisteredAddress': AddressViewModelToJSON(value.registeredAddress),
    };
}

